import React from "react";
import { Navigate, useLocation } from "react-router";

// misc
import auth from "../../auth/auth";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const stored = auth.getAuth();

  return stored?.token?.jwtToken ? (
    children
  ) : (
    <Navigate to={"/login"} replace state={{ from: location }} />
  );
};

export default ProtectedRoute;
